import * as React from "react";
import { Show, SimpleShowLayout, useRecordContext, Button, TextField, FunctionField } from 'react-admin';
const PageTitle = () => {
  const record = useRecordContext();
  return <span>Payment proof for {record ? `${record.profile_id}` : ''}</span>;
};
const ConvertBuymotePointDetail = ({ ...props }) => (

  <Show title={<PageTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="profile_id" label="Profile Id" />
      <TextField source="name" label="Name" />
      <TextField source="buymote_name" label="Buymote name" />
      <TextField source="total_amount" label="Point" />
      <TextField source="phone" label="Phone" />
      <TextField source="req_datetime" label="Request datet" />
      <TextField label="Approved by" source="approvedby.name" />
      <TextField label="Approved Date" source="approved_date" />
      <TextField label="Decline by" source="declineby.name" />
      <TextField label="Decline Reason" source="decline_reason" />
      <FunctionField source="req_status" label="Status" render={record => {
        if (record['req_status'] === 'Decline') {
          return (<Button style={{ color: 'red', border: '1px solid' }} label="Decline" size="small"></Button>)
        } else if (record['req_status'] === 'Pending') {
          return (<Button style={{ color: 'orange', border: '1px solid' }} label="Pending" size="small"></Button>)
        } else if (record['req_status'] === 'Sent') {
          return (<Button style={{ color: 'green', border: '1px solid' }} label="Sent" size="small"></Button>)
        }
      }} />      
    </SimpleShowLayout>
  </Show>
);
export default ConvertBuymotePointDetail